import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Pagination,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";



import {
  ArrowDropDown,
  Badge,
  EditNote,
  EventAvailable,
  Group,
  Home,
  School,
  SentimentDissatisfied,
  Visibility,
  Wc,Download
} from "@mui/icons-material";
import CallIcon from "@mui/icons-material/Call";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PersonIcon from "@mui/icons-material/Person";
import SpaIcon from "@mui/icons-material/Spa";
import TaskIcon from "@mui/icons-material/Task";
import useDebouncedValue from "hooks/useDebouncedValue";
import { FarmerLevelTab } from "./FarmerLevelTab";
import { useSelector } from "react-redux";
import { selectCurrentRoles } from "features/auth/authSlice";
import { CMS_maati } from "urlconfig";
import { FgdLevelTab } from "./FgdLevelTab";

export const FGDLevelHclNewUi = ({
  ids,
  crop,
  districtValue,
  blockValue,
  GpValue,
}) => {
  const [farmers, setFarmers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFarmer, setSelectedFarmer] = useState(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(25);
  const [total, setTotal] = useState(0);
  const [searchKey, setSearchKey] = useState("");
  const debouncedSearch = useDebouncedValue(searchKey);
  const RolesFromToken = useSelector(selectCurrentRoles);

  useEffect(() => {
    const params = new URLSearchParams();

    if (blockValue) {
      params.append("filters[block]", blockValue);
    }
    if (districtValue) {
      params.append("filters[district]", districtValue);
    }
    if (GpValue) {
      params.append("filters[grampanchayat]", GpValue);
    }
    if (crop) {
      if (ids?.length) {
        ids.forEach((id) => params.append("filters[documentId][$in]", id));
      } else {
        setFarmers([]);
        setLoading(false);
        return;
      }
    }
    if (debouncedSearch) {
      params.append(
        "filters[$or][0][name_of_respondent][$containsi]",
        debouncedSearch
      );
      params.append(
        "filters[$or][1][mobile_number][$containsi]",
        debouncedSearch
      );
    }
    params.append("filters[type_of_respondent][$ne]", "Farmer");
    params.append("pagination[page]", page);
    params.append("pagination[pageSize]", pageSize);
    params.append("sort[0]", "createdAt:desc");

    // const url = `https://agrani-cms.leadsconnect.in/api/basic-details?${params.toString()}`;
      const url = `${CMS_maati}/api/fgd-basic-details?${params.toString()}`;


    setLoading(true);
    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        const uniqueFarmers = Array.from(
          new Map(
            (data?.data ?? []).map((farmer) => [farmer.id, farmer])
          ).values()
        );

        setFarmers(uniqueFarmers);

        setTotal(data?.meta?.pagination?.total || uniqueFarmers.length);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching farmer data:", err);
        setLoading(false);
      });
  }, [
    districtValue,
    blockValue,
    GpValue,
    crop,
    ids,
    page,
    pageSize,
    debouncedSearch,
  ]);

  const handleEditClick = (farmer) => {
    setSelectedFarmer(farmer);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedFarmer(null);
  };
  const handlePageChange = (event, value) => {
    setPage(value);
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <CircularProgress />
        <Typography variant="subtitle1" mt={2}>
          Loading FGD Details...
        </Typography>
      </Box>
    );
  }
  console.log("fgd level",farmers)

  const DetailRow = ({ icon: Icon, label, value, color }) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        backgroundColor: "#fafafa",
        "&:hover": { backgroundColor: "#f5f5f5" },
        transition: "0.2s",
        flex: 1,
        minWidth: 220,
      }}
    >
      <Box
        sx={{
          background: color.bg,
          color: color.text,
          borderRadius: "50%",
          width: 32,
          height: 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon fontSize="small" />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Typography
          variant="caption"
          sx={{ fontWeight: 600, color: "text.secondary", lineHeight: 1.2 }}
        >
          {label}
        </Typography>

        {Array.isArray(value) ? (
          <Box
            sx={{
              mt: 0.5,
              display: "flex",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            {[...new Set(value.map((v) => String(v)))]
              .sort((a, b) => a?.localeCompare(b))
              .map((item, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    mb: 0.3,
                  }}
                >
                  <Checkbox
                    checked
                    sx={{
                      p: 0,
                      width: 16,
                      height: 16,
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                      },
                      color: color.text,
                      "&.Mui-checked": { color: "green" },
                    }}
                  />
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: 500, marginTop: 0.1 }}
                  >
                    {item}
                  </Typography>
                </Box>
              ))}
          </Box>
        ) : (
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: 1.3 }}>
            {value || "N/A"}
          </Typography>
        )}
      </Box>
    </Box>
  );

  const handleChangeSearch = (message) => {
    setPage(1);
    setSearchKey(message);
  };

  const downloadCSV = async () => {
    try {
      const params = new URLSearchParams();

      if (blockValue) params.append("filters[block]", blockValue);
      if (districtValue) params.append("filters[district]", districtValue);
      if (GpValue) params.append("filters[grampanchayat]", GpValue);
      if (crop) {
        if (ids?.length) {
          ids.forEach((id) => params.append("filters[documentId][$in]", id));
        } else {
          return;
        }
      }

      params.append("filters[type_of_respondent][$ne]", "Farmer");
      params.append("pagination[page]", 1);
      params.append("pagination[pageSize]", 100);

      const url = `${CMS_maati}/api/fgd-basic-details?${params.toString()}`;


      const res = await fetch(url);
      const data = await res.json();

      const farmers = Array.from(
        new Map(
          (data?.data ?? []).map((farmer) => [farmer.id, farmer])
        ).values()
      );

      if (!farmers.length) return;

      const headers = [
        "Onboarding Date",
        "Name",
        "Mobile",
        "Gender",
        "Age",
        "DOB",
        "Respondent Type",
        "Address",
        "Completed Forms",
      ];

      const csvRows = [];
      csvRows.push(headers.join(","));

      farmers.forEach((farmer) => {
        const row = [
          farmer.createdAt ? farmer.createdAt.slice(0, 10) : "",
          farmer.name_of_respondent || "",
          farmer.mobile_number || "",
          farmer.gender || "",
          farmer.age || "",
          farmer.dob || "",
          farmer.type_of_respondent || "",
          `${farmer.district || ""}, ${farmer.block || ""}, ${farmer.address ||
            ""}`,
          Array.isArray(farmer.completed_list)
            ? farmer.completed_list.join(" , ")
            : "",
        ];
        csvRows.push(row.map((val) => `"${val}"`).join(","));
      });

      const csvContent = csvRows.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv" });
      const urlBlob = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = urlBlob;
      link.setAttribute("download", "farmers_data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("CSV Download Error:", error);
    }
  };
  const isProjectMaati = RolesFromToken?.preferred_username === "6789067890";
  return (
    <Box sx={{ p: 3 }}>
      <div className="d-flex flex-lg-row flex-column align-items-center justify-content-between mt-3 mb-3">
        <TextField
          size="small"
          placeholder="Search by Name or Mobile Number"
          value={searchKey}
          onChange={(e) => handleChangeSearch(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: searchKey && (
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={() => handleChangeSearch("")}
                  edge="end"
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
          sx={{
            minWidth: 300,
            "& .MuiInputBase-input": {
              fontSize: 14,
              padding: "9px 2px",
            },
          }}
        />

        <h5 className=" text-center mb-2">👨‍🌾 FGD Level Data</h5>

        <div
          className="d-flex align-items-center justify-content-end gap-3"
          style={{ minWidth: 300 }}
        >
          <h6 className="m-0 text-end">
            Total : <span className="text-success">{total}</span>
          </h6>
          {!isProjectMaati && (
            <Button
              variant="contained"
              color="warning"
              size="small"
              startIcon={<Download />}
              onClick={() => downloadCSV(farmers)}
            >
              CSV
            </Button>
          )}
        </div>
      </div>
      {/* <Grid container spacing={2}>
        {farmers.length > 0 ? (
          farmers.map((farmer) => (
            <Grid item xs={12} key={farmer.id}>
              <Card
                sx={{
                  borderRadius: "14px",
                  overflow: "hidden",
                  transition: "0.3s",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                }}
              >
                <Box
                  sx={{
                    color: "black",
                    p: 2,
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    alignItems: { xs: "flex-start", sm: "center" },
                    justifyContent: "space-between",
                    gap: { xs: 1, sm: 2 },
                    position: "relative",
                    borderBottom: "1px solid #eee",
                    boxShadow: "inset 0 -2px 0 #f0f0f0",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 2,
                      flexWrap: "wrap",
                    }}
                  >
                    <Avatar
                      sx={{
                        width: 46,
                        height: 46,
                        background: "linear-gradient(135deg, #ffecb3, #ffcc80)",
                      }}
                    >
                      <PersonIcon sx={{ fontSize: 26 }} />
                    </Avatar>

                    <Box>
                      <Typography variant="subtitle1" fontWeight={700} noWrap>
                        {farmer.name_of_respondent}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          opacity: 0.75,
                          display: "flex",
                          alignItems: "center",
                          gap: 0.5,
                          flexWrap: "wrap",
                        }}
                      >
                        <span className="text-black">Onboarding Date:</span>{" "}
                        {farmer.createdAt.slice(0, 10)}
                      </Typography>
                    </Box>
                  </Box>

                  <IconButton
                    onClick={() => handleEditClick(farmer)}
                    sx={{
                      position: { xs: "absolute", sm: "static" },
                      top: { xs: 8, sm: "auto" },
                      right: { xs: 8, sm: "auto" },
                    }}
                  >
                    <Visibility fontSize="small" sx={{ color: "#ff9800" }} />
                  </IconButton>
                </Box>

                <CardContent sx={{ p: 2 }}>
                
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                        <DetailRow
                          icon={CallIcon}
                          label="Mobile"
                          value={farmer.mobile_number}
                          color={{ bg: "#FFCDD2", text: "#B71C1C" }}
                        />
                        <DetailRow
                          icon={Wc}
                          label="Gender & Age"
                          value={`${farmer.gender}, ${farmer.age} yrs`}
                          color={{ bg: "#FCE4EC", text: "#D81B60" }}
                        />
                        <DetailRow
                          icon={CalendarToday}
                          label="age"
                          value={farmer.age}
                          color={{ bg: "#EDE7F6", text: "#5E35B1" }}
                        />
                        <DetailRow
                          icon={School}
                          label="Type of Respondent"
                          value={farmer.type_of_respondent}
                          color={{ bg: "#E8EAF6", text: "#283593" }}
                        />
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={farmer?.completed_list?.length ? 12 : 6}
                    >
                      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                        <DetailRow
                          icon={Home}
                          label="Address"
                          value={`${farmer.district}, ${farmer.block}, ${farmer.address}`}
                          color={{ bg: "#E3F2FD", text: "#1565C0" }}
                        />
                        {farmer?.completed_list?.length && (
                          <DetailRow
                            icon={TaskIcon}
                            label="Completed Forms"
                            value={farmer.completed_list}
                            color={{ bg: "#F3E5F5", text: "#7B1FA2" }}
                          />
                        )}
                      </Box>
                    </Grid>
                    
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <SentimentDissatisfied sx={{ fontSize: 48, color: "#ff9800" }} />
              <Typography
                variant="h6"
                fontWeight={600}
                sx={{ color: "text.secondary" }}
              >
                No Data Found
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                Looks like there are no farmer records available yet.
              </Typography>
            </Box>
          </Grid>
        )}
      </Grid> */}
        <Grid container spacing={2}>
              {farmers?.length > 0 ? (
                farmers?.map((farmer) => (
                  <Grid item xs={12} key={farmer?.id}>
                    <Card
                      sx={{
                        borderRadius: "14px",
                        overflow: "hidden",
                        transition: "0.3s",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                      }}
                    >
                      <Box
                        sx={{
                          color: "black",
                          p: 2,
                          display: "flex",
                          flexDirection: { xs: "column", sm: "row" },
                          alignItems: { xs: "flex-start", sm: "center" },
                          justifyContent: "space-between",
                          gap: { xs: 1, sm: 2 },
                          position: "relative",
                          borderBottom: "1px solid #eee",
                          boxShadow: "inset 0 -2px 0 #f0f0f0",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 2,
                            flexWrap: "wrap",
                          }}
                        >
                          <Avatar
                            sx={{
                              width: 46,
                              height: 46,
                              background: "linear-gradient(135deg, #ffecb3, #ffcc80)",
                            }}
                          >
                            <PersonIcon sx={{ fontSize: 26 }} />
                          </Avatar>
      
                          <Box>
                            <Typography variant="subtitle1" fontWeight={700} noWrap>
                              {farmer?.name_of_respondent}
                            </Typography>
                            <Typography
                              variant="body2"
                              sx={{
                                opacity: 0.75,
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                flexWrap: "wrap",
                              }}
                            >
                              <span className="text-black">Onboarding Date:</span>{" "}
                              {farmer?.createdAt?.slice(0, 10)}
                            </Typography>
                          </Box>
                        </Box>
      
                        <div className="d-flex">
                          <IconButton onClick={() => handleEditClick(farmer)}>
                            <Visibility fontSize="small" sx={{ color: "#ff9800" }} />
                          </IconButton>
                          {/* <IconButton onClick={() => handleEditFarmer(farmer)}>
                            <EditNote fontSize="small" sx={{ color: "#ff9800" }} />
                          </IconButton> */}
                        </div>
                      </Box>
      
                      <CardContent sx={{ p: 2 }}>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                              <DetailRow
                                icon={CallIcon}
                                label="Mobile Number"
                                value={farmer?.mobile_number}
                                color={{ bg: "#FFCDD2", text: "#B71C1C" }}
                              />
                              <DetailRow
                                icon={Wc}
                                label="Gender"
                                value={`${farmer?.gender}`}
                                color={{ bg: "#FCE4EC", text: "#D81B60" }}
                              />
                              <DetailRow
                                icon={EventAvailable}
                                label="Age"
                                value={`${farmer?.age} yrs`}
                                color={{ bg: "#EDE7F6", text: "#5E35B1" }}
                              />
                              <DetailRow
                                icon={School}
                                label="Education Level"
                                value={farmer?.education_level}
                                color={{ bg: "#E8EAF6", text: "#283593" }}
                              />
                            </Box>
                          </Grid>
      
                        
                          <Grid
                            item
                            xs={farmer?.completed_list?.length ? 12 : 6}
                          >
                            <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                              {console.log("farmer",farmer)}
                              <DetailRow
                                icon={Home}
                                label="Address"
                                value={`${farmer?.district}, ${farmer?.block}, ${
                                  farmer?.gram_panchayat
                                } ,${farmer?.address || ""} `}
                                color={{ bg: "#E3F2FD", text: "#1565C0" }}
                              />
                              {farmer?.completed_list?.length && (
                                <DetailRow
                                  icon={TaskIcon}
                                  label="Completed Forms"
                                  value={farmer?.completed_list}
                                  color={{ bg: "#F3E5F5", text: "#7B1FA2" }}
                                />
                              )}
                            </Box>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                ))
              ) : (
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <SentimentDissatisfied sx={{ fontSize: 48, color: "#ff9800" }} />
                    <Typography
                      variant="h6"
                      fontWeight={600}
                      sx={{ color: "text.secondary" }}
                    >
                      No Data Found
                    </Typography>
                    <Typography variant="body2" sx={{ opacity: 0.7 }}>
                      Looks like there are no farmer records available yet.
                    </Typography>
                  </Box>
                </Grid>
              )}
            </Grid>
      {farmers.length > 0 && total > 0 && (
        <Box
          sx={{
            mt: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            Page {page} of {Math.ceil(total / pageSize)} • Total {total} Farmers
          </Typography>

          {total > pageSize && (
            <Pagination
              count={Math.ceil(total / pageSize)}
              page={page}
              onChange={handlePageChange}
              color="primary"
              shape="rounded"
            />
          )}
        </Box>
      )}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle> Details</DialogTitle>
        <DialogContent dividers>
          {/* <FarmerLevelTab
            formType="fgd_level"
            documentId={selectedFarmer?.documentId}
          /> */}
          <FgdLevelTab
            selectedFarmer={selectedFarmer}
            documentId={selectedFarmer?.documentId}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
